/**
 * CTR Combo Flavor Timeline — mobile slider controls
 */
(function () {
  'use strict';

  const SELECTOR = '.ctr-combo-flavor-timeline';
  const MQ_DESKTOP = window.matchMedia('(min-width: 990px)');

  function initSection(section) {
    if (!section || section.dataset.cftBound === 'true') return;
    section.dataset.cftBound = 'true';

    const track = section.querySelector('[data-cft-track]');
    const prevBtn = section.querySelector('[data-cft-prev]');
    const nextBtn = section.querySelector('[data-cft-next]');
    const dots = Array.from(section.querySelectorAll('[data-cft-dot]'));
    const cards = track ? Array.from(track.querySelectorAll('.ctr-combo-flavor-timeline__card')) : [];

    if (!track || cards.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function scrollStep() {
      const card = cards[0];
      if (!card) return track.clientWidth * 0.8;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 24;
      return card.getBoundingClientRect().width + gap;
    }

    function currentIndex() {
      const left = track.scrollLeft;
      const step = scrollStep();
      if (step <= 0) return 0;
      return Math.round(left / step);
    }

    function maxIndex() {
      return Math.max(0, cards.length - 1);
    }

    function updateControls() {
      if (MQ_DESKTOP.matches) return;

      const index = Math.min(currentIndex(), maxIndex());
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

      if (prevBtn) {
        prevBtn.disabled = atStart;
        prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      }
      if (nextBtn) {
        nextBtn.disabled = atEnd;
        nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }

      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      const clamped = Math.max(0, Math.min(index, maxIndex()));
      const behavior = prefersReducedMotion.matches ? 'auto' : 'smooth';
      track.scrollTo({ left: clamped * scrollStep(), behavior });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => goTo(currentIndex() - 1));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => goTo(currentIndex() + 1));
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goTo(i));
    });

    let scrollRaf = 0;
    track.addEventListener(
      'scroll',
      () => {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(updateControls);
      },
      { passive: true }
    );

    MQ_DESKTOP.addEventListener('change', updateControls);
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.(SELECTOR) || event.target.closest?.(SELECTOR);
    if (section) {
      section.dataset.cftBound = '';
      initSection(section);
    }
  });
})();
